import {SUCCESS_TOAST, CLEAR_TOAST, ERROR_TOAST} from '../actions/ToasterAction'
const initialState ={
    toaster: {},    
}

const ToasterReducer = (state = initialState, action) => {
    let toast
    switch(action.type){
        case SUCCESS_TOAST:
            toast = {summary: action.summary, detail: action.detail, severity:'success', life:3000}
            return {...state, toaster: toast}
        case ERROR_TOAST:
            toast = {summary: action.summary, detail: action.detail, severity:'error', life:3000}
            return {...state, toaster: toast}
        case CLEAR_TOAST:
            return {...state, toaster: {}}
        default:
            return {...state}
    }
}

export default ToasterReducer;
